import { useEffect } from "react";
import { fontGroups } from "../fonts/fontGroups.js";

export const useFontManagement = (selectedFont) => {
  useEffect(() => {
    const selected = fontGroups
      .flatMap((group) => group.fonts)
      .find((f) => f.value === selectedFont);
    if (!selected) return;

    const id = "dynamic-font-link";
    const fontHref = `https://fonts.googleapis.com/css2?family=${selected.google}&display=swap`;

    let link = document.getElementById(id);
    if (link) {
      if (link.href !== fontHref) link.href = fontHref;
    } else {
      link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = fontHref;
      document.head.appendChild(link);
    }

    document.documentElement.style.setProperty("--bubble-font", selectedFont);
  }, [selectedFont]);
};
